import './summits.less'

import {Icon} from '@codeurs/front'
import React from 'react'
import {LinkType, SubeventType, WysiwygType} from 'types'
import {Link} from 'util/link'
import {style} from 'util/style'
import {SubeventLogo} from 'views/layout/subeventlogo'
import {Theme} from 'views/theme'

const styles = style('summits', ['item'])

export type SummitsType = {
	items?: Array<SummitsItemType>
}

export type SummitsItemType = {
	logo?: SubeventType
	date?: string
	text?: WysiwygType
	button?: LinkType
	disclaimer?: WysiwygType
}

export const Summits: React.FC<SummitsType> = ({items}) => {
	if (!items || items.length === 0) return null
	const showDisclaimer = items.some(item => !!item?.disclaimer)

	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					<div className={styles('row').mod('col' + items.length)}>
						{items.map((item, i) => (
							<div
								className={styles('row-col').mod(
									showDisclaimer ? 'disclaimer' : ''
								)}
								key={i}
							>
								<SummitsItem {...item} showDisclaimer={showDisclaimer} />
							</div>
						))}
					</div>
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}

export const SummitsItem: React.FC<SummitsItemType & {
	showDisclaimer: boolean
}> = ({logo, date, text, button, disclaimer, showDisclaimer}) => {
	const ItemTag = button?.url ? Link : 'div'
	const itemProps = button?.url ? {to: button.url} : {}

	return (
		<ItemTag {...itemProps} className={styles.item().mod(logo)}>
			<div className={styles.item('content')}>
				<div className={styles.item('content-top')}>
					{logo && (
						<SubeventLogo
							subevent={logo}
							className={styles.item('content-logo')}
						/>
					)}
					{logo && (date || text) && (
						<span className={styles.item('content-line')} />
					)}
					{date && <p className={styles.item('content-date')}>{date}</p>}
					{text && (
						<div className={styles.item('content-text')}>
							<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
						</div>
					)}
				</div>
				{button && button.url && (
					<div className={styles.item('content-button')}>
						<span className={styles.item('content-button-text')}>
							{button.description || button.title}
						</span>
						<span className={styles.item('content-button-icon')}>
							<Icon icon="arrow-right" />
						</span>
					</div>
				)}
				{showDisclaimer && (
					<div
						className={styles
							.item('content-disclaimer')
							.mod(disclaimer ? '' : 'hide')}
					>
						<Theme.Wysiwyg>{disclaimer}</Theme.Wysiwyg>
					</div>
				)}
			</div>
		</ItemTag>
	)
}
